import React, { useRef } from "react";
import { useFormik } from "formik";
import { Checkbox, FormHelperText, TextField } from "@mui/material";
import styles from "./KontaktForm.module.css";
import * as yup from "yup";
import emailjs from "@emailjs/browser";

const validationSchema = yup.object({
  email: yup.string().email().required(),
  phone: yup.string().required(""),
  firstName: yup.string().notRequired(),
  lastName: yup.string().required(""),
  subject: yup.string().required(""),
  message: yup.string().required(""),
  consent: yup.boolean().oneOf([true], ""),
});

const KontaktForm = () => {
  const form = useRef<HTMLFormElement>(null);
  const formik = useFormik({
    initialValues: {
      email: "",
      phone: "",
      firstName: "",
      lastName: "",
      subject: "",
      message: "",
      consent: false,
    },
    validationSchema: validationSchema,
    onSubmit: (_) => {
      if (form.current === null) return;

      emailjs
        .sendForm("service_vv9p98o", "template_3bjo06m", form.current, {
          publicKey: "90SOxxwLt7a80ivHJ",
        })
        .then()
        .catch((e) => {
          console.error(e);
        });
    },
  });

  return (
    <>
      <div>
        <form
          onSubmit={formik.handleSubmit}
          className={styles.contactForm}
          ref={form}
        >
          <div className={styles.gridLeft}>
            <TextField
              name="firstName"
              placeholder="Vorname ¹"
              value={formik.values.firstName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{
                backgroundColor: "white",
              }}
              error={
                formik.touched.firstName && Boolean(formik.errors.firstName)
              }
              helperText={formik.touched.firstName && formik.errors.firstName}
            />
          </div>
          <div className={styles.gridRight}>
            <TextField
              name="lastName"
              placeholder="Nachname ²"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.lastName && Boolean(formik.errors.lastName)}
              helperText={formik.touched.lastName && formik.errors.lastName}
              style={{
                backgroundColor: "white",
              }}
            />
          </div>
          <div className={styles.gridLeft}>
            <TextField
              name="email"
              placeholder="E-Mail ³"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              style={{
                backgroundColor: "white",
              }}
            />
          </div>
          <div className={styles.gridRight}>
            <TextField
              name="phone"
              placeholder="Telefon ⁴"
              value={formik.values.phone}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.phone && Boolean(formik.errors.phone)}
              helperText={formik.touched.phone && formik.errors.phone}
              style={{
                backgroundColor: "white",
              }}
            />
          </div>
          <div className={styles.gridStretch}>
            <TextField
              name="subject"
              placeholder="Betreff ⁵"
              value={formik.values.subject}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.subject && Boolean(formik.errors.subject)}
              helperText={formik.touched.subject && formik.errors.subject}
              style={{
                backgroundColor: "white",
              }}
            />
          </div>
          <div className={styles.gridStretch}>
            <TextField
              name="message"
              placeholder="Nachricht ⁶"
              multiline
              rows={4}
              value={formik.values.message}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.message && Boolean(formik.errors.message)}
              helperText={formik.touched.message && formik.errors.message}
              style={{
                backgroundColor: "white",
              }}
            />
          </div>
          <div
            className={styles.gridLeft}
            style={{
              fontSize: "0.7em",
              whiteSpace: "pre",
              fontWeight: "bold",
            }}
          >
            1 Wenn ich dich duzen darf
            <br />
            2 Wenn ich Sie...
            <br />
            3 Wenn ich schreiben soll
            <br />
            4 Wenn ich anrufen soll
            <br />
            5 Damit ich weiß, <br /> {"  "}worum es geht
            <br />
            6 Macht Sinn, oder?
            <br />7 Muss leider sein
          </div>
          <div className={styles.gridSubmit}>
            <div className={styles.checkBox}>
              <div style={{ whiteSpace: "pre", textAlign: "end" }}>
                ⁷ Mit der Datenschutzerklärung <br />
                {"  "}bin ich einverstanden
              </div>
              <Checkbox
                style={{
                  padding: 0,
                  margin: 0,
                  marginLeft: "0.5em",
                }}
                name="consent"
                checked={formik.values.consent}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.consent && formik.errors.consent ? (
                <FormHelperText error>{formik.errors.consent}</FormHelperText>
              ) : null}
            </div>

            <div className={styles.buttonContainer}>
              <button
                type="submit"
                disabled={formik.isSubmitting}
                className={styles.button}
              >
                Senden
              </button>
            </div>
          </div>
          <div
            className={styles.gridRight}
            style={{ display: "flex", justifyContent: "flex-end" }}
          ></div>
        </form>
      </div>
    </>
  );
};

export default KontaktForm;
